import { Component, OnInit } from '@angular/core';
import { UserStoreService } from 'src/app/services/user/user-store.service';

@Component({
  selector: 'app-xs-header-dashboard',
  templateUrl: './xs-header-dashboard.component.html',
  styleUrls: ['./xs-header-dashboard.component.scss'],
})
export class XsHeaderDashboardComponent implements OnInit {
  showOverloading: boolean;
  token: string;
  flagVerOperacion: string;
  juridico:any;
  constructor(
    public userStore: UserStoreService,
  ) {}

  ngOnInit() {
    this.flagVerOperacion = (this.userStore && this.userStore.activeCUC && this.userStore.activeCUC.flagVerOperacion)?this.userStore.activeCUC.flagVerOperacion:'';
    if(this.userStore.COGNITO_USER && (this.userStore.COGNITO_USER.username.includes('ruc') || this.userStore.COGNITO_USER.username.includes('opj'))){
      this.juridico=true;
    }
    else{
      this.juridico=false;
    }
  }

}
